import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RESULT_CONTAINERS_LIST } from 'shared/enums';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { clearNavigationActions } from './helpers';
import { IResultNavigationModeState } from './interfaces';

export const initialState = {
  mode: RESULT_CONTAINERS_LIST.EPS,
  loading: 'idle',
} as IResultNavigationModeState;

export const resetResultNavigationTabsModeAction = createAsyncThunk(
  'resultModeNavigation/reset',
  async (_, { dispatch }) => {
    dispatch(resetResultModeAction());
    dispatch(clearNavigationActions[initialState.mode]());
  },
);

export const setResultModeAction = createAsyncThunk<
  RESULT_CONTAINERS_LIST,
  RESULT_CONTAINERS_LIST,
  { rejectValue: IMyKnownError }
>('resultModeNavigation/set', async (payload, { dispatch }) => {
  dispatch(resetResultNavigationTabsModeAction());
  return payload;
});

const resultNavigationModeSlice = createSlice({
  name: 'resultModeNavigation',
  initialState,
  reducers: {
    resetResultModeAction: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(setResultModeAction.fulfilled, (state, { payload }) => {
      state.mode = payload;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      return state;
    });
    builder.addCase(setResultModeAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
  },
});
const { reducer, actions } = resultNavigationModeSlice;
export const { resetResultModeAction } = actions;
export default reducer;
